import { MutationTree } from 'vuex';
import { State } from './state';
import { Bestellung } from '@/modules/ewwms/models/Lager/BestellungenModels';
import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';
import { ArchivComponenteFile } from '@/modules/ewwms/models/ArchivModels';

export enum MutationTypes {
  SetBestellungen = 'SETBESTELLUNGEN',
  SetUpdatedBestellung = 'UPDATEBESTELLUNGSUCCESS',
  AddPalette = 'ADDPALETTE',
  AddOrUpdatePaletten = 'ADDPALETTEN',
  AddOrUpdatePalette = 'ADDORUPDATEPALETTE',
  SetInitDate = 'SETINITDATE',
  SetBestellungDoc = 'SETBESTELLUNGDOC',
}

export type Mutations = {
  [MutationTypes.SetBestellungen](state: State, data: Array<Bestellung>): void;
  [MutationTypes.SetUpdatedBestellung](state: State, data: Bestellung): void;

  [MutationTypes.AddPalette](state: State, data: Listeartikel): void;
  [MutationTypes.AddOrUpdatePaletten](state: State, data: Array<Listeartikel>): void;
  [MutationTypes.AddOrUpdatePalette](state: State, data: Listeartikel): void;

  [MutationTypes.SetInitDate](state: State, date: Date): void;

  [MutationTypes.SetBestellungDoc](state: State, date: ArchivComponenteFile | null): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SetBestellungen](state, data) {
    state.bestellungen = data;
    sessionStorage.setItem('bestellungen', JSON.stringify(state.bestellungen));
  },

  [MutationTypes.SetUpdatedBestellung](state, data) {
    removeBestellung(state.bestellungen, data.id);

    if (state.bestellungen == null) {
      state.bestellungen = new Array<Bestellung>();
    }

    state.bestellungen.push(data);
    sessionStorage.setItem('bestellungen', JSON.stringify(state.bestellungen));
  },

  [MutationTypes.AddPalette](state, data) {
    if (state.paletten.indexOf(data) === -1) {
      state.paletten.push(data);
    }
  },

  [MutationTypes.AddOrUpdatePaletten](state, data) {
    for (const palette of data) {
      const index = state.paletten.findIndex((b) => b.id == palette.id);
      if (index === -1) {
        state.paletten.push(palette);
      } else {
        state.paletten.splice(index, 1, palette);
      }
    }
  },

  [MutationTypes.AddOrUpdatePalette](state, data) {
    // var index = state.paletten.indexOf(data);
    const index = state.paletten.findIndex((b) => b.id == data.id);
    if (index === -1) {
      state.paletten.push(data);
    } else {
      state.paletten.splice(index, 1, data);
    }
  },

  [MutationTypes.SetInitDate](state, date) {
    state.initDate = date;
  },

  [MutationTypes.SetBestellungDoc](state, data) {
    state.bestellungDoc = data;
  },
};

function removeBestellung(bestellungen: Array<Bestellung>, bestellungid: number): void {
  const index = bestellungen.findIndex((b) => b.id == bestellungid);
  if (index != -1) {
    bestellungen.splice(index, 1);
  }

  return;
}
